import baseApi from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return baseApi.post(`api-blob/api/storage-groups/v1`, form);
  },
  fetchById(id) {
    return baseApi.get(`api-blob/api/storage-groups/v1/${id}`);
  },
  fetch() {
    return baseApi.get(`api-blob/api/storage-groups/v1`);
  },
  remove(id) {
    return baseApi.delete(`api-blob/api/storage-groups/v1/${id}`);
  },
}
